import { __ } from '../helpers/i18n';

/* global themeVars */
const { templateUrl } = themeVars

let shareDropdownCounter = 1000;

/**
 * Displays a share dropdown menu for a given post.
 *
 * @param {Object} post - The post object to share.
 * @return {String} HTML representing the share dropdown menu.
 */
export function shareDropdown( post ) {

	const encodedTitle = encodeURIComponent( post.title );
	const dropdownId = `c-share-dropdown-items-${ ++shareDropdownCounter }`;

	return `
		<div class="c-share-dropdown-btn js-share-dropdown-btn">
			<button
				type="button"
				class="c-share-dropdown-btn__trigger js-share-dropdown-trigger"
				aria-expanded="false"
				aria-controls="${ dropdownId }"
				aria-label="${ __( 'Udostępnij' ) }"
			>
				<img src="${templateUrl}/img/icons/icon-share.svg" alt="" aria-hidden="true" width="24" height="24" class="c-share-dropdown-btn__icon">
			</button>
			<div class="c-share-dropdown-items c-share-dropdown-items--align-right" id="${ dropdownId }" hidden>
				<span class="c-share-dropdown-items__text">${__( 'Udostępnij' )}</span>
				<ul class="c-share-dropdown-items__list">
					<li class="c-share-dropdown-items__li">
						<button type="button" class="c-share-dropdown-items-link c-share-dropdown-items-link--copy js-share-copy-link" data-share-link="${post.url}" aria-label="${__( 'Kopiuj link artykułu' )}">
							<img src="${templateUrl}/img/social-media/icon-link.svg" alt="" class="c-share-dropdown-items-link__icon" loading="lazy" decoding="async" width="24" height="24" aria-hidden="true">
								<span class="c-share-dropdown-items-link__label">
									${__( 'Kopiuj link artykułu' )}
								</span>
								<span class="c-share-dropdown-items-link__status js-share-copy-link-status" aria-live="polite" aria-hidden="true">
									${__( 'Skopiowano' )}
								</span>
						</button>
					</li>
                    <li class="c-share-dropdown-items__li">
                        <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=${post.url}&amp;title=${encodedTitle}" class="c-share-dropdown-items-link" target="_blank" rel="noopener noreferrer" aria-label="${__( 'Udostępnij na LinkedIn' )}">
                            <img src="${templateUrl}/img/social-media/icon-in.svg" alt="" class="c-share-dropdown-items-link__icon" loading="lazy" decoding="async" width="24" height="24" aria-hidden="true">
                                ${__( 'Udostępnij na LinkedIn' )}
                        </a>
                    </li>
					<li class="c-share-dropdown-items__li">
						<a href="https://twitter.com/intent/tweet?url=${post.url}&amp;text=${encodedTitle}" class="c-share-dropdown-items-link" target="_blank" rel="noopener noreferrer" aria-label="${__( 'Udostępnij na Twitterze' )}">
							<img src="${templateUrl}/img/social-media/icon-x.svg" alt="" class="c-share-dropdown-items-link__icon" loading="lazy" decoding="async" width="24" height="24" aria-hidden="true">
								${__( 'Udostępnij na Twitterze' )}
						</a>
					</li>
					<li class="c-share-dropdown-items__li">
						<a href="https://www.facebook.com/sharer/sharer.php?u=${post.url}" class="c-share-dropdown-items-link" target="_blank" rel="noopener noreferrer" aria-label="${__( 'Udostępnij na Facebooku' )}">
							<img src="${templateUrl}/img/social-media/icon-fb.svg" alt="" class="c-share-dropdown-items-link__icon" loading="lazy" decoding="async" width="24" height="24" aria-hidden="true">
								${__( 'Udostępnij na Facebooku' )}
						</a>
					</li>
					<li class="c-share-dropdown-items__li">
						<a href="mailto:?subject=${encodedTitle}&amp;body=${__( 'Sprawdź%20ten%20artykuł' )}:%20${post.url}" class="c-share-dropdown-items-link" target="_blank" rel="noopener noreferrer" aria-label="${__( 'Udostępnij przez e-mail' )}">
							<img src="${templateUrl}/img/social-media/icon-mail.svg" alt="" class="c-share-dropdown-items-link__icon" loading="lazy" decoding="async" width="24" height="24" aria-hidden="true">
								${__( 'Udostępnij przez e-mail' )}
						</a>
					</li>
				</ul>
			</div>
		</div>
    `;

}
